
import actions from "@/store/common/actions";
import { defineComponent, SetupContext, ref } from "vue";
export default defineComponent({
  name: "SearchTagItem",
  props: {
    /**
     * タグ名
     */
    label: {
      type: String,
      required: true
    },
    /**
     * 検索タグ種別
     */
    alias: {
      type: String,
      required: true
    },
    /**
     * 検索タグ（TODO）
     */
    id: {
      type: Number,
      required: true
    },
    /**
     * 選択状態
     */
    active: {
      type: Boolean,
      required: true
    },
    /**
     * 選択状態
     */
    deleteIcon: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    /**
     * タグ押下を通知する
     */
    const onClick = () => {
      context.emit("select-tag", props.alias, props.id);
    };

    /**
     * アイテムの背景色を取得する
     */
    const getItemBackgroundColor = () => {
      return getComputedStyle(document.documentElement).getPropertyValue(
        props.active ? "--main-theme-color" : "--main-tag-bg-color"
      );
    };

    /**
     * アイテムの文字色を取得する
     */
    const getItemFontColor = () => {
      return getComputedStyle(document.documentElement).getPropertyValue(
        props.active ? "--tag-select-text-color" : "--main--text-color"
      );
    };

    return {
      onClick,
      getItemBackgroundColor,
      getItemFontColor
    };
  }
});
